module.exports = __webpack_public_path__ + "img/Plus-icon.f837f7b0.svg";